// tslint:disable
import { find } from 'lodash';
import { AspireDetails } from './details/aspire.details';
import { AtasDetails } from './details/atas.details';
import { AtasEnquiry } from './details/atas.enquiry';
import { AtasMember } from './details/atas.member';
import { AtasTraining } from './details/atas.training';
import { DefaultAgendaSpeaker } from './details/default.agenda-speaker';
import { DefaultAirline } from './details/default.airline';
import { DefaultArticle } from './details/default.article';
import { DefaultArticleCategory } from './details/default.article-category';
import { DefaultArticleDestination } from './details/default.article-destination';
import { DefaultArticleHolidayType } from './details/default.article-holiday-type';
import { DefaultArticleReview } from './details/default.article-review';
import { DefaultArticleTag } from './details/default.article-tag';
import { DefaultBenefit } from './details/default.benefit';
import { DefaultBenefitCategory } from './details/default.benefit-category';
import { DefaultBenefitDiscount } from './details/default.benefit-discount';
import { DefaultBenefitMembershipLevel } from './details/default.benefit-membership-level';
import { DefaultBenefitType } from './details/default.benefit-type';
import { DefaultBoardMember } from './details/default.board-member';
import { DefaultBooking } from './details/default.booking';
import { DefaultBusinessType } from './details/default.business-type';
import { DefaultCarHire } from './details/default.car-hire';
import { DefaultCity } from './details/default.city';
import { DefaultCompany } from './details/default.company';
import { DefaultCompanyAdmin } from './details/default.company-admin';
import { DefaultCompanyArticle } from './details/default.company-article';
import { DefaultCompanyPage } from './details/default.company-page';
import { DefaultCompanyPageType } from './details/default.company-page-type';
import { DefaultCompanySiteSpec } from './details/default.company-site-spec';
import { DefaultContact } from './details/default.contact';
import { DefaultCountry } from './details/default.country';
import { DefaultEvent } from './details/default.event';
import { DefaultEventAgenda } from './details/default.event-agenda';
import { DefaultEventAttendee } from './details/default.event-attendee';
import { DefaultEventCategory } from './details/default.event-category';
import { DefaultEventContact } from './details/default.event-contact';
import { DefaultEventContactType } from './details/default.event-contact-type';
import { DefaultEventGuestType } from './details/default.event-guest-type';
import { DefaultEventPeriod } from './details/default.event-period';
import { DefaultEventPlace } from './details/default.event-place';
import { DefaultFaq } from './details/default.faq';
import { DefaultForm } from './details/default.form';
import { DefaultHolidayType } from './details/default.holiday-type';
import { DefaultIssue } from './details/default.issue';
import { DefaultJob } from './details/default.job';
import { DefaultMailTemplate } from './details/default.mail-template';
import { DefaultMediaAlbum } from './details/default.media-album';
import { DefaultMediaAlbumImage } from './details/default.media-album-image';
import { DefaultMediaCategory } from './details/default.media-category';
import { DefaultMediaTag } from './details/default.media-tag';
import { DefaultMembershipType } from './details/default.membership-type';
import { DefaultModalSetNewPassword } from './details/default.modal-set-new-password';
import { DefaultModalTeamMember } from './details/default.modal-team-member';
import { DefaultModalUserAccess } from './details/default.modal-user-access';
import { DefaultModalUserAccessSubscription } from './details/default.modal-user-access-subscription';
import { DefaultModalCompanyAdmin } from './details/default.modal.company-admin';
import { DefaultModalCompanyPage } from './details/default.modal.company-page';
import { DefaultModalFaq } from './details/default.modal.faq';
import { DefaultModalPersonCompany } from './details/default.modal.person-company';
import { DefaultModalUser } from './details/default.modal.user';
import { DefaultPage } from './details/default.page';
import { DefaultPerson } from './details/default.person';
import { DefaultPersonCompany } from './details/default.person-company';
import { DefaultPoint } from './details/default.point';
import { DefaultPointReason } from './details/default.point-reason';
import { DefaultSite } from './details/default.site';
import { DefaultTeamMember } from './details/default.team-member';
import { DefaultTourOperator } from './details/default.tour-operator';
import { DefaultTurnover } from './details/default.turnover';
import { DefaultUser } from './details/default.user';
import { ELearningTranslations } from './details/e-learning-translations';
import { Confirm } from './libs/confirm';
import { InputPrompt } from './libs/input-prompt';
import { MediaManager } from './libs/media-manager';
import { UserAttachPerson } from './libs/user-attach-person';
import { AtasEnquiryList } from './lists/atas.enquiry.list';
import { AtasMemberList } from './lists/atas.member.list';
import { AtasTraingingList } from './lists/atas.trainging.list';
import { DefaultAirlineList } from './lists/default.airline.list';
import { DefaultArticleCategoryList } from './lists/default.article-category.list';
import { DefaultArticleDestinationList } from './lists/default.article-destination.list';
import { DefaultArticleHolidayTypeList } from './lists/default.article-holiday-type.list';
import { DefaultArticleReviewList } from './lists/default.article-review.list';
import { DefaultArticleTagList } from './lists/default.article-tag.list';
import { DefaultArticleList } from './lists/default.article.list';
import { DefaultBenefitCategoryList } from './lists/default.benefit-category.list';
import { DefaultBenefitDiscountList } from './lists/default.benefit-discount.list';
import { DefaultBenefitMembershipLevelList } from './lists/default.benefit-membership-level.list';
import { DefaultBenefitTypeList } from './lists/default.benefit-type.list';
import { DefaultBenefitList } from './lists/default.benefit.list';
import { DefaultBoardMemberList } from './lists/default.board-member.list';
import { DefaultBookingList } from './lists/default.booking.list';
import { DefaultBusinessTypeList } from './lists/default.business-type.list';
import { DefaultCarHireList } from './lists/default.car-hire.list';
import { DefaultCityList } from './lists/default.city.list';
import { DefaultCompanyAdminList } from './lists/default.company-admin.list';
import { DefaultCompanyArticlelist } from './lists/default.company-article.list';
import { DefaultCompanyPageTypeList } from './lists/default.company-page-type.list';
import { DefaultCompanyPageList } from './lists/default.company-page.list';
import { DefaultCompanyList } from './lists/default.company.list';
import { DefaultContactList } from './lists/default.contact.list';
import { DefaultCountryList } from './lists/default.country.list';
import { DefaultEventCategoryList } from './lists/default.event-category.list';
import { DefaultEventContactTypeList } from './lists/default.event-contact-type.list';
import { DefaultEventGuestTypeList } from './lists/default.event-guest-type.list';
import { DefaultEventPeriodList } from './lists/default.event-period.list';
import { DefaultEventPlaceList } from './lists/default.event-place.list';
import { DefaultEventList } from './lists/default.event.list';
import { DefaultFaqList } from './lists/default.faq.list';
import { DefaultFormList } from './lists/default.form.list';
import { DefaultHolidayTypeList } from './lists/default.holiday-type.list';
import { DefaultIssueList } from './lists/default.issue.list';
import { DefaultJobList } from './lists/default.job.list';
import { DefaultMailTemplateList } from './lists/default.mail-template.list';
import { DefaultMediaAlbumList } from './lists/default.media-album.list';
import { DefaultMediaCategoryList } from './lists/default.media-category.list';
import { DefaultMediaTagList } from './lists/default.media-tag.list';
import { DefaultMembershipTypeList } from './lists/default.membership-type.list';
import { DefaultPageList } from './lists/default.page.list';
import { DefaultPersonCompanyList } from './lists/default.person-company.list';
import { DefaultPersonList } from './lists/default.person.list';
import { DefaultPointReasonList } from './lists/default.point-reason.list';
import { DefaultPointList } from './lists/default.point.list';
import { DefaultSiteList } from './lists/default.site.list';
import { DefaultTeamMemberList } from './lists/default.team-member.list';
import { DefaultTourOperatorList } from './lists/default.tour-operator.list';
import { DefaultTurnoverList } from './lists/default.turnover.list';
import { DefaultUserList } from './lists/default.user';
import { DefaultSidebar } from './sidebar/default.sidebar';
import {DefaultMainCarouselList} from "./lists/default.main-carousel.list";
import {DefaultMainCarousel} from "./details/default.main-carousel";

export class TemplateItem {
    public type: string;
    public entity?: string;
    public site?: string;
    public component: any;
}

export class Templates {
    private sources: TemplateItem[] = [];

    constructor() {
        this.sources = [
            //COMMON


            // Site
            {type: 'list', entity: 'site', component: DefaultSiteList},
            {type: 'details', entity: 'site', component: DefaultSite},

            // Media Manager
            {type: 'list', entity: 'file-manager', component: MediaManager},

            // Input prompt
            {type: 'list', entity: '__input-prompt', component: InputPrompt},

            // Confirm
            {type: 'list', entity: 'confirm', component: Confirm},

            // Sidebar
            {type: 'sidebar', component: DefaultSidebar},

            // Benefit
            {type: 'list', entity: 'benefit', component: DefaultBenefitList},
            {type: 'details', entity: 'benefit', component: DefaultBenefit},

            // Benefit
            {type: 'list', entity: 'main-carousel', component: DefaultMainCarouselList},
            {type: 'details', entity: 'main-carousel', component: DefaultMainCarousel},

            // Benefit category
            {type: 'list', entity: 'benefit-category', component: DefaultBenefitCategoryList},
            {type: 'details', entity: 'benefit-category', component: DefaultBenefitCategory},

            // Benefit membership level
            {type: 'list', entity: 'benefit-membership-level', component: DefaultBenefitMembershipLevelList},
            {type: 'details', entity: 'benefit-membership-level', component: DefaultBenefitMembershipLevel},

            // Benefit discount
            {type: 'list', entity: 'benefit-discount', component: DefaultBenefitDiscountList},
            {type: 'details', entity: 'benefit-discount', component: DefaultBenefitDiscount},

            // Benefit type
            {type: 'list', entity: 'benefit-type', component: DefaultBenefitTypeList},
            {type: 'details', entity: 'benefit-type', component: DefaultBenefitType},

            // Article
            {type: 'list', entity: 'article', component: DefaultArticleList},
            {type: 'details', entity: 'article', component: DefaultArticle},

            // Article Destination
            {type: 'list', entity: 'article-destination', component: DefaultArticleDestinationList},
            {type: 'details', entity: 'article-destination', component: DefaultArticleDestination},

            // Article Review
            {type: 'list', entity: 'article-review', component: DefaultArticleReviewList},
            {type: 'details', entity: 'article-review', component: DefaultArticleReview},

            // Article Tag
            {type: 'list', entity: 'article-tag', component: DefaultArticleTagList},
            {type: 'details', entity: 'article-tag', component: DefaultArticleTag},

            // Article Holiday type
            {type: 'list', entity: 'article-holiday-type', component: DefaultArticleHolidayTypeList},
            {type: 'details', entity: 'article-holiday-type', component: DefaultArticleHolidayType},

            // Person
            {type: 'list', entity: 'person', component: DefaultPersonList},
            {type: 'details', entity: 'person', component: DefaultPerson},

            // Person-Company
            {type: 'list', entity: 'person-company', component: DefaultPersonCompanyList},
            {type: 'details', entity: 'person-company', component: DefaultPersonCompany},

            //Membership Type
            {type: 'list', entity: 'membership-type', component: DefaultMembershipTypeList},
            {type: 'details', entity: 'membership-type', component: DefaultMembershipType},

            //Company Page
            {type: 'list', entity: 'company-page', component: DefaultCompanyPageList},
            {type: 'details', entity: 'company-page', component: DefaultCompanyPage},

            //Company Page Type
            {type: 'list', entity: 'company-page-type', component: DefaultCompanyPageTypeList},
            {type: 'details', entity: 'company-page-type', component: DefaultCompanyPageType},

            //Company Article
            {type: 'list', entity: 'company-article', component: DefaultCompanyArticlelist},
            {type: 'details', entity: 'company-article', component: DefaultCompanyArticle},

            // User-attach
            {type: 'details', entity: 'user-attach-person', component: UserAttachPerson},

            // User
            {type: 'list', entity: 'user', component: DefaultUserList},
            {type: 'details', entity: 'user', component: DefaultUser},

            // Bussiness Type
            {type: 'list', entity: 'business-type', component: DefaultBusinessTypeList},
            {type: 'details', entity: 'business-type', component: DefaultBusinessType},

            //Turnover
            {type: 'list', entity: 'turnover', component: DefaultTurnoverList},
            {type: 'details', entity: 'turnover', component: DefaultTurnover},

            //Team members
            {type: 'list', entity: 'team-member', component: DefaultTeamMemberList},
            {type: 'details', entity: 'team-member', component: DefaultTeamMember},

            //Company Site Spec
            {type: 'details', entity: 'company-site-spec', component: DefaultCompanySiteSpec},

            //Company Admin
            {type: 'list', entity: 'company-admin', component: DefaultCompanyAdminList},
            {type: 'details', entity: 'company-admin', component: DefaultCompanyAdmin},

            //FAQ
            {type: 'list', entity: 'faq', component: DefaultFaqList},
            {type: 'details', entity: 'faq', component: DefaultFaq},

            // Media album
            {type: 'list', entity: 'media-album', component: DefaultMediaAlbumList},
            {type: 'details', entity: 'media-album', component: DefaultMediaAlbum},

            //Media Album Image
            {type: 'details', entity: 'media-album-image', component: DefaultMediaAlbumImage},

            // Media Category
            {type: 'details', entity: 'media-category', component: DefaultMediaCategory},
            {type: 'list', entity: 'media-category', component: DefaultMediaCategoryList},

            // Media tag
            {type: 'details', entity: 'media-tag', component: DefaultMediaTag},
            {type: 'list', entity: 'media-tag', component: DefaultMediaTagList},

            // ATAS ceges oldal
            {type: 'details', entity: 'sd', component: AspireDetails},
            {type: 'details', entity: 'sd', component: AtasDetails, site: 'atas'},

            // Enquiry
            {type: 'list', entity: 'enquiry', component: AtasEnquiryList},
            {type: 'details', entity: 'enquiry', component: AtasEnquiry},

            // Contact
            {type: 'list', entity: 'contact', component: DefaultContactList},
            {type: 'details', entity: 'contact', component: DefaultContact},

            // City
            {type: 'list', entity: 'city', component: DefaultCityList},
            {type: 'details', entity: 'city', component: DefaultCity},

            // Country
            {type: 'list', entity: 'country', component: DefaultCountryList},
            {type: 'details', entity: 'country', component: DefaultCountry},

            // Job
            {type: 'list', entity: 'job', component: DefaultJobList},
            {type: 'details', entity: 'job', component: DefaultJob},

            // Page
            {type: 'list', entity: 'page', component: DefaultPageList},
            {type: 'details', entity: 'page', component: DefaultPage},

            // Mail Template
            {type: 'list', entity: 'mail-template', component: DefaultMailTemplateList},
            {type: 'details', entity: 'mail-template', component: DefaultMailTemplate},

            //ATAS
            //Members
            {type: 'list', entity: 'member', component: AtasMemberList, site: 'atas'},
            {type: 'details', entity: 'member', component: AtasMember, site: 'atas'},

            // Member
            {type: 'list', entity: 'company', component: DefaultCompanyList, site: 'atas'},
            {type: 'details', entity: 'company', component: DefaultCompany, site: 'atas'},

            // CompanyPage - Training - only ATAS
            {type: 'list', entity: 'atas-training', component: AtasTraingingList, site: 'atas'},
            {type: 'details', entity: 'atas-training', component: AtasTraining, site: 'atas'},

            // Article Category
            {type: 'list', entity: 'article-category', component: DefaultArticleCategoryList},
            {type: 'details', entity: 'article-category', component: DefaultArticleCategory},


            // Events
            {type: 'list', entity: 'event', component: DefaultEventList},
            {type: 'details', entity: 'event', component: DefaultEvent},

            // Event Place
            {type: 'list', entity: 'event-place', component: DefaultEventPlaceList},
            {type: 'details', entity: 'event-place', component: DefaultEventPlace},

            // Event Category
            {type: 'list', entity: 'event-category', component: DefaultEventCategoryList},
            {type: 'details', entity: 'event-category', component: DefaultEventCategory},

            // Event Guest Type
            {type: 'list', entity: 'guest-type', component: DefaultEventGuestTypeList},
            {type: 'details', entity: 'guest-type', component: DefaultEventGuestType},

            // Event Period
            {type: 'list', entity: 'period', component: DefaultEventPeriodList},
            {type: 'details', entity: 'period', component: DefaultEventPeriod},

            // Event Agenda
            //{type: 'list', entity: 'event-agenda', component: DefaultEventPeriodList},
            {type: 'details', entity: 'event-agenda', component: DefaultEventAgenda},

            // Event Agenda Speaker
            //{type: 'list', entity: 'agenda-speaker', component: DefaultEventPeriodList},
            {type: 'details', entity: 'agenda-speaker', component: DefaultAgendaSpeaker},

            // Event Attendee
            {type: 'details', entity: 'attendee', component: DefaultEventAttendee},

            // Event Contact
            {type: 'details', entity: 'event-contact', component: DefaultEventContact},

            // Event Contact Type
            {type: 'list', entity: 'event-contact-type', component: DefaultEventContactTypeList},
            {type: 'details', entity: 'event-contact-type', component: DefaultEventContactType},

            // Issue
            {type: 'list', entity: 'issue', component: DefaultIssueList},
            {type: 'details', entity: 'issue', component: DefaultIssue},

            // Board member
            {type: 'list', entity: 'board-member', component: DefaultBoardMemberList},
            {type: 'details', entity: 'board-member', component: DefaultBoardMember},

            // Point reason
            {type: 'list', entity: 'point-reason', component: DefaultPointReasonList},
            {type: 'details', entity: 'point-reason', component: DefaultPointReason},

            // Point
            {type: 'list', entity: 'point', component: DefaultPointList},
            {type: 'details', entity: 'point', component: DefaultPoint},

            // Point
            {type: 'list', entity: 'booking', component: DefaultBookingList},
            {type: 'details', entity: 'booking', component: DefaultBooking},


            // Car hire
            {type: 'list', entity: 'car-hire', component: DefaultCarHireList},
            {type: 'details', entity: 'car-hire', component: DefaultCarHire},

            // Tour Operator
            {type: 'list', entity: 'tour-operator', component: DefaultTourOperatorList},
            {type: 'details', entity: 'tour-operator', component: DefaultTourOperator},

            // Tour Operator
            {type: 'list', entity: 'holiday-type', component: DefaultHolidayTypeList},
            {type: 'details', entity: 'holiday-type', component: DefaultHolidayType},

            // Ariline
            {type: 'list', entity: 'airline', component: DefaultAirlineList},
            {type: 'details', entity: 'airline', component: DefaultAirline},


            {type: 'details', entity: 'modal-person-company', component: DefaultModalPersonCompany, site: 'atas'},
            {type: 'details', entity: 'modal-team-member', component: DefaultModalTeamMember, site: 'atas'},
            {type: 'details', entity: 'modal-company-page', component: DefaultModalCompanyPage, site: 'atas'},
            {type: 'details', entity: 'modal-faq', component: DefaultModalFaq},
            {type: 'details', entity: 'modal-company-admin', component: DefaultModalCompanyAdmin},
            {type: 'details', entity: 'modal-user', component: DefaultModalUser},
            {type: 'details', entity: 'modal-set-new-password', component: DefaultModalSetNewPassword},
            {type: 'details', entity: 'modal-user-access', component: DefaultModalUserAccess},
            {type: 'details', entity: 'modal-user-access-subscription', component: DefaultModalUserAccessSubscription},


            {type: 'list', entity: 'e-learning-translations', component: ELearningTranslations},


            // Form
            {type: 'list', entity: 'form', component: DefaultFormList},
            {type: 'details', entity: 'form', component: DefaultForm}


        ];
    }

    public getTemplate(entity: string, type: string, site?: string) {
        const defaultSidebar = find(this.sources, (i: any) => (i.type === 'sidebar'));
        const specificSidebar = find(this.sources, (i: any) => (i.type === 'sidebar' && i.site && (i.site === (site || '').toLowerCase())));

        const defaultItem = find(this.sources, (i: any) => (i.entity === entity && i.type === type));
        const specificItem = find(this.sources, (i: any) => (i.entity === entity && i.type === type && i.site && (i.site === (site || '').toLowerCase())));
        return specificItem || defaultItem || (!entity && (specificSidebar || defaultSidebar));
    }
}



// WEBPACK FOOTER //
// ./src/__templates/templates.ts